var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner-until"},[(!_vm.ready)?_c('div',{staticClass:"text-center spinner-until__spinner"},[_c('b-spinner',{attrs:{"variant":"primary"}})],1):_vm._e(),(_vm.ready)?_c('div',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }